import { Box, CircularProgress, Tooltip, Typography } from "@mui/material";

export function CircularProgressIcon({ enable = true, confidence_score }) {
  const rawConfidenceScore = Number(confidence_score);

  const confidencePercent = Number.isFinite(rawConfidenceScore)
    ? Math.min(
        100,
        Math.max(0, Math.floor(parseFloat(rawConfidenceScore) * 100)),
      )
    : null;

  const confidenceColor =
    confidencePercent >= 80
      ? "#22c55e"
      : confidencePercent >= 50
        ? "#f59e0b"
        : "#ef4444";

  if (!confidence_score || !enable) return null;

  return (
    <Tooltip title={`Confidence: ${confidencePercent}%`} arrow placement="bottom">
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          background: "rgba(15, 23, 42, 0.82)",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.35)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          variant="determinate"
          value={100}
          size={40}
          thickness={4}
          sx={{ color: "rgba(255,255,255,0.2)", position: "absolute" }}
        />
        <CircularProgress
          variant="determinate"
          value={confidencePercent}
          size={40}
          thickness={4}
          sx={{ color: confidenceColor, position: "absolute" }}
        />
        <Typography
          variant="caption"
          sx={{
            position: "relative",
            zIndex: 1,
            fontWeight: 700,
            fontSize: "0.75rem",
          }}
        >
          {confidencePercent}%
        </Typography>
      </Box>
    </Tooltip>
  );
}
